export default __webpack_public_path__ + "static/media/iconZoom.f16f33ea.svg";